/**
 * Toast hook compatible with shadcn/ui API
 * Wraps Sonner to provide a consistent API
 */

import { toast as sonnerToast } from 'sonner';

export interface ToastProps {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
  duration?: number;
}

export function useToast() {
  const toast = ({ title, description, variant = 'default', duration }: ToastProps) => {
    const message = description ? `${title ? `${title}: ` : ''}${description}` : title || '';

    if (variant === 'destructive') {
      sonnerToast.error(message, { duration });
    } else {
      // Default variant maps to success toast
      sonnerToast.success(message, { duration });
    }
  };

  return {
    toast,
  };
}

